// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"86bef771","947":"05987f78"}[chunkId] + ".chunk.js";
};